export default __webpack_public_path__ + "static/media/eng_5.0166b658.png";